import React from 'react';

import { StyledIcon } from '../StyledIcon';

export const Threats = props => (
  <StyledIcon viewBox='0 0 24 24' a11yTitle='Threats' {...props}>
    <path fill='none' stroke='#000' strokeWidth='2' d='M9,23 C12.8659932,23 16,19.8659932 16,16 C16,12.1340068 12.8659932,9 9,9 C5.13400675,9 2,12.1340068 2,16 C2,19.8659932 5.13400675,23 9,23 Z M9,6 C9,6 9,8 9,5 C9,2 11,1 13,1 C15,1 17,2 17,5 L17,8 C17,9 17,11 19,11 C21,11 21,9 21,8 C21,6 22,6 23,6 M12,13 L6,19 M6,13 L12,19 M6,10 L6,6 L12,6 L12,10' />
  </StyledIcon>
);
